/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupplierDto as DigiworkMaitreDPosDtoSuppliersSupplierDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';

export interface GetSupplier$Params {
  supplierId: string;
}

export function getSupplier(http: HttpClient, rootUrl: string, params: GetSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>> {
  const rb = new RequestBuilder(rootUrl, getSupplier.PATH, 'get');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoSuppliersSupplierDto>;
    })
  );
}

getSupplier.PATH = '/api/suppliers/{supplierId}';
